import {AdvertisementActions, IAdvertisementState} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import * as actions from "./actions";

const initialState: IAdvertisementState = {
    adIsShowing: false,
    rewardedAdIsAvailable: false,
    interstitialAdIsAvailable: false,
};

export const advertisementReducer: Reducer<IAdvertisementState, AdvertisementActions> = (state = initialState, action) => {
    switch (action.type) {
        case getType(actions.loadAds):
            return {
                ...state,
                [action.payload + "AdIsAvailable"]: true
            };

        case getType(actions.showAds):
            return {
                ...state,
                adIsShowing: true
            };

        case getType(actions.closeAds):
            return {
                ...state,
                adIsShowing: false,
                interstitialAdIsAvailable: action.payload.adType === 'rewarded' && action.payload.success
                    ? false
                    : state.interstitialAdIsAvailable
            };

        case getType(actions.watchAds):
            return {
                ...state,
                [action.payload.adType + "AdIsAvailable"]: false
            };

        default:
            return state;
    }
};
